module.exports = __webpack_public_path__ + "img/favorites.05239fcc.png";